import STORAGE_KEYS from '../../Storage/storageKeys';
import { APICache } from './APICache';
import { storeEpg, loadEpg, clearEpgStorage } from './helpers';

const loadItem = async (storage, key) => {
    const item = await storage.getItem(key);
    return item?.data || {};
};

const storeCache = (storage, cache) => {
    const { CHANNELS, CHANNELS_BRIEF } = STORAGE_KEYS.API_CACHE;
    const { channels, channelsBrief, epg } = cache.getCache();
    storage.setItem(CHANNELS_BRIEF, { data: channelsBrief });
    storage.setItem(CHANNELS, { data: channels });
    storeEpg(storage, epg);
};

const clearCache = async (id, storage) => {
    const { CHANNELS, CHANNELS_BRIEF, EPG } = STORAGE_KEYS.API_CACHE;
    switch (id) {
        case CHANNELS:
            await storage.removeItem(CHANNELS);
            break;
        case CHANNELS_BRIEF:
            await storage.removeItem(CHANNELS_BRIEF);
            break;
        case EPG:
            await clearEpgStorage(storage);
            break;
        default:
            break;
    }
};

const loadCache = async (storage) => {
    const { CHANNELS, CHANNELS_BRIEF } = STORAGE_KEYS.API_CACHE;
    const channelsBrief = await loadItem(storage, CHANNELS_BRIEF);
    const channels = await loadItem(storage, CHANNELS);
    const epg = await loadEpg(storage);
    return {
        channels,
        channelsBrief,
        epg
    };
};

export const initializeCache = async (storage) => {
    let initialCache = {};
    try {
        initialCache = await loadCache(storage);
    } catch (error) {
        console.log(error);
    }
    const changeHandler = async (id, cache, clear = false) => {
        if (clear) {
            await clearCache(id, storage);
        } else {
            await storeCache(storage, cache);
        }
    };
    return new APICache(changeHandler, {});
};
